module.exports = __webpack_public_path__ + "static/Guia_da_Marca_HostDime-821cd37c2a08552a556e8aa6fbfab774.pdf";